const projectsActions = {
  SET_SEARCH_PARAMS: 'SET_SEARCH_PARAMS',
  UPDATE_PROJECTS_LIST: 'UPDATE_PROJECTS_LIST',
  DEACTIVATE_JOB: 'DEACTIVATE_JOB',
  REFRESH_PROJECTS_LIST_START: 'REFRESH_PROJECTS_LIST_START',
  REFRESH_PROJECTS_LIST_DONE: 'REFRESH_PROJECTS_LIST_DONE',
  RENAME_PROJECT: 'RENAME_PROJECT',
  DELETE_PROJECT: 'DELETE_PROJECT',
  CHANGE_FOLDER: 'CHANGE_FOLDER',
  SET_FOLDER_TARGET: 'SET_FOLDER_TARGET',
  SET_SETTINGS_TARGET: 'SET_SETTINGS_TARGET',
  SET_APPLICATION_STATUS_TARGET: 'SET_APPLICATION_STATUS_TARGET',

  setSearchParams: (payload: String) => ({
    type: projectsActions.SET_SEARCH_PARAMS,
    payload,
  }),

  updateProjectsList: (payload: { projects: any }) => ({
    type: projectsActions.SET_SEARCH_PARAMS,
    payload,
  }),

  deactivateJob: (payload: { id: number }) => ({
    type: projectsActions.DEACTIVATE_JOB,
    payload,
  }),

  renameProject: (payload: any) => ({
    type: projectsActions.RENAME_PROJECT,
    payload,
  }),

  deleteProject: (payload: { id: number }) => ({
    type: projectsActions.DELETE_PROJECT,
    payload,
  }),

  changeFolder: (payload: { fromProject: any; toProject?: any; newProject?: any }) => ({
    type: projectsActions.CHANGE_FOLDER,
    payload,
  }),

  setFolderTarget: (payload: any) => ({
    type: projectsActions.SET_FOLDER_TARGET,
    payload,
  }),

  setSettingsTarget: (payload: any) => ({
    type: projectsActions.SET_SETTINGS_TARGET,
    payload,
  }),

  setApplicationStatusTarget: (payload: any) => ({
    type: projectsActions.SET_APPLICATION_STATUS_TARGET,
    payload,
  }),
};

export default projectsActions;
